export enum EntityTypeEnum {
  EO = 'EO',
  FACILITY = 'FACILITY',
  MACHINE = 'MACHINE'
}
